<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{paddingTop:'10px'}">
      <Breadcrumb routeName="PcWeb" toName="新增" cneterName="公司新闻" goPathName="PC网站"></Breadcrumb>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="currentFormLayout2.labelCol"
        :wrapper-col="currentFormLayout2.wrapperCol">
        <a-form-model-item label="内容标题" prop="title">
          <a-input
            v-model="ruleForm.title"
            placeholder="请输入"
            :maxLength="60"
            style="max-width:500px;"/>
        </a-form-model-item>
        <a-form-model-item label="内容正文" prop="content">
          <div style="max-width: 800px">
            <CustomUeditor v-model="ruleForm.content" :config="myConfig" :destroy="true"></CustomUeditor>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
          <a-button style="margin-left: 3%;" @click="goReset">重置</a-button>
          <a-button style="margin-left: 3%;" @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'

export default {
  name: 'AddCompanyNews',
  components: {
    Breadcrumb,
    CustomUeditor
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      ruleForm: {
        title: '',
        content: ''
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      submitLoading: false,
      id: '',
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        serverUrl: this.getFwbFileUrl(),
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true
      }
    }
  },
  activated() {
    this.goReset()
    this.id = this.$route.query.id
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    getFwbFileUrl() {
      let appConfig = this.getAppConfig()
      this.getLogUtils().logWithTag('getFwbFileUrl', appConfig)
      return appConfig.fwbUrl
    },
    getDetails() {
      let url = 'pc/v2/corporation-news/' + this.id
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.content = res.content
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    goReset() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.handleOk()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    handleOk() {
      let parms = {
        title: this.ruleForm.title,
        content: this.ruleForm.content
      }
      if (this.id) {
        parms.id = this.id
      }
      this.submitLoading = true
      this.getHttpServices().getUserService().post('pc/v2/corporation-news/save', parms).then(res => {
        this.$message.success('保存成功')
        this.submitLoading = false
        this.goBack()
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.submitLoading = false
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.image-hint {
  margin-left: 20px;
}
</style>